export const CURRENCY = {
  HUF: 'HUF',
  EUR: 'EUR'
}
